export { default as ContactDepartmentEdit } from './ContactDepartmentEdit';
export { default as ContactDepartmentList } from './ContactDepartmentList';